webpackJsonp([4],{

/***/ 115:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1692);

/***/ }),

/***/ 1692:
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(67)(
  /* script */
  __webpack_require__(877),
  /* template */
  __webpack_require__(2294),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/home/runner/work/vux/vux/docs/node_modules/v-markdown-loader/_cache/README-31.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] README-31.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-641f0385", Component.options)
  } else {
    hotAPI.reload("data-v-641f0385", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),

/***/ 2294:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', {
    attrs: {
      "align": "center"
    }
  }, [_c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://vux-demos.bobjoy.eu.org?x-page=v2-doc-home"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://img.picui.cn/free/2024/10/30/6721eec153bd7.png",
      "width": "100",
      "alt": ""
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://vux-demos.bobjoy.eu.org?x-page=v2-doc-home"
    }
  }, [_vm._v("\n    预览地址>>\n  ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://img.shields.io/github/stars/airyland/vux.svg?style=social&label=Star",
      "alt": ""
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://img.shields.io/github/forks/airyland/vux.svg?style=social&label=Fork",
      "alt": ""
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://img.shields.io/github/watchers/airyland/vux.svg?style=social&label=Watch",
      "alt": ""
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://img.shields.io/github/issues/airyland/vux.svg?style=flat-square",
      "alt": ""
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://isitmaintained.com/badge/resolution/airyland/vux.svg?style=flat-square",
      "alt": ""
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/graphs/contributors"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://img.shields.io/github/contributors/airyland/vux.svg?style=flat-square",
      "alt": ""
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.npmjs.com/package/vux"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://img.shields.io/npm/l/vux.svg?style=flat-square",
      "alt": ""
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.npmjs.com/package/vux"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://img.shields.io/npm/v/vux.svg?style=flat-square",
      "alt": ""
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.npmjs.com/package/vux"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://img.shields.io/npm/dm/vux.svg?style=flat-square",
      "alt": ""
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.npmjs.com/package/vux"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://img.shields.io/npm/dt/vux.svg?style=flat-square",
      "alt": ""
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "warning"
  }, [_c('p', [_vm._v("VUX 必须配合 "), _c('code', [_vm._v("vux-loader")]), _vm._v(" 使用，请按照"), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/tree/v2/packages/vue-cli-3-example"
    }
  }, [_vm._v("https://github.com/airyland/vux/tree/v2/packages/vue-cli-3-example")]), _vm._v("配置。"), _c('br')]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("less@3.x")]), _vm._v(" 有严重的兼容问题，请暂时使用 "), _c('strong', [_vm._v("less@^2.7.3")]), _vm._v("。")]), _vm._v(" "), _c('p', [_vm._v("vux-loader 工具是针对webpack+vue-loader项目的工程化工具，简化了webpack插件和loader的使用和编写，支持在vue-loader处理之前进行预处理，同时内置对vux组件专用的配置和优化插件。 详见 vux-loader readme.md")])]), _vm._v(" "), _c('h2', [_vm._v("简介")]), _vm._v(" "), _c('p', [_c('code', [_vm._v("VUX")]), _vm._v("（读音 [v’ju:z]，同 "), _c('code', [_vm._v("views")]), _vm._v("）是基于"), _c('code', [_vm._v("WeUI")]), _vm._v("和"), _c('code', [_vm._v("Vue")]), _vm._v("(2.x)开发的移动端UI组件库，主要服务于微信页面。")]), _vm._v(" "), _c('p', [_vm._v("基于"), _c('code', [_vm._v("webpack + vue-loader + vux")]), _vm._v("可以快速开发移动端页面，配合"), _c('code', [_vm._v("vux-loader")]), _vm._v("方便你在"), _c('code', [_vm._v("WeUI")]), _vm._v("的基础上定制需要的样式。")]), _vm._v(" "), _c('p', [_c('code', [_vm._v("vux-loader")]), _vm._v("保证了组件按需使用，因此不用担心最终打包了整个vux的组件库代码。")]), _vm._v(" "), _c('p', [_c('code', [_vm._v("VUX")]), _vm._v("并不完全依赖于"), _c('code', [_vm._v("WeUI")]), _vm._v("，"), _c('code', [_vm._v("VUX")]), _vm._v(" 在 "), _c('code', [_vm._v("WeUI")]), _vm._v(" 的基础上扩展了多个常用组件，但是尽量保持整体UI样式接近"), _c('code', [_vm._v("WeUI")]), _vm._v("的设计规范。")]), _vm._v(" "), _c('div', {
    staticClass: "warning"
  }, [_c('p', [_vm._v("VUX 并不是一个能解决所有场景的完美解决方案(实际上也没有一个方案能解决所有问题)，也会出现某些"), _c('code', [_vm._v("bug")]), _vm._v("或者某些特性不支持，所以如果遇到问题麻烦及时"), _c('strong', [_vm._v("不带情绪正确反馈")]), _vm._v("，"), _c('strong', [_vm._v("我们乐于及时解决描述详细方便重现的问题")]), _vm._v("。"), _c('br'), _c('br'), _vm._v("\n即使你不直接使用 "), _c('code', [_vm._v("VUX")]), _vm._v(" 组件代码, 你依然可以参考 VUX 代码来实现自己的组件库。如果一定程度上帮助到了你，那么维护这个项目也就有所意义。")])]), _vm._v(" "), _c('h2', [_vm._v("提示")]), _vm._v(" "), _c('div', {
    staticClass: "tip"
  }, [_c('p', [_c('code', [_vm._v("VUX")]), _vm._v(" 是"), _c('code', [_vm._v("库")]), _vm._v("而非"), _c('code', [_vm._v("框架")]), _vm._v("，虽然有专用的 "), _c('code', [_vm._v("vux-loader")]), _vm._v("，但并不影响你自由地使用其他组件库或者工具库。"), _c('br'), _c('br')]), _vm._v(" "), _c('p', [_c('code', [_vm._v("VUX")]), _vm._v(" 使用的 CSS 预处理工具是 "), _c('code', [_vm._v("less")]), _vm._v("(同 WeUI)，但(利益于 .vue 单文件组件的灵活性)这并不影响你使用 "), _c('code', [_vm._v("SASS")]), _vm._v(" 等其他预处理器。"), _c('br'), _c('br')]), _vm._v(" "), _c('p', [_vm._v("用以表示该组件库时请使用大写名字 "), _c('code', [_vm._v("VUX")]), _vm._v("，用在说明版本号时使用小写 "), _c('code', [_vm._v("vux@2.x")]), _vm._v("。")])])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-641f0385", module.exports)
  }
}

/***/ }),

/***/ 877:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  head: { "title": "关于 VUX | VUX - Vue 移动端 UI 组件库", "ignoreSuffixChar": "|" }
});

/***/ })

});


// WEBPACK FOOTER //
// 4.ceceb293.js